<!-- <div class="{{ className }}">
  <div class="heading-secondary">
    <span>{{ text }}</span>
  </div>
  <button class="btn-square-sm" *ngIf="hasButton">
    <div matTooltip="{{ tooltipText }}" ngClass="plus-bold"></div>
  </button>
  <mat-divider *ngIf="hasDivider" class="divider-themed"></mat-divider>
</div> -->

<div *ngIf="!isHyperLink" class="inpage-heading">
  <div class="inpage-header">
      <h5>{{ text }}</h5>
      <span class="right-btn">
          <itb-square-button [tooltipText]="tooltipText" [iconClassName]="iconClassName" [className]="'btn-square-sm'" *ngIf="hasButton" ></itb-square-button>
      </span>     
      <!-- <button class="btn-square-sm" *ngIf="hasButton"></button> -->
  </div>
  <itb-divider [className]="'mat-divider divider-themed'" *ngIf="hasDivider" ></itb-divider>
</div>

<div *ngIf="isHyperLink" class="inpage-heading">
  <div class="inpage-header">
    <a href="{{link}}" target="_blank" rel="noopener"> <h5>{{ text }}</h5> </a>
      <span class="right-btn">
          <itb-square-button [tooltipText]="tooltipText" [iconClassName]="iconClassName" [className]="'btn-square-sm'" *ngIf="hasButton" ></itb-square-button>
      </span>     
      <!-- <button class="btn-square-sm" *ngIf="hasButton"></button> -->
  </div>
  <itb-divider [className]="'mat-divider divider-themed'" *ngIf="hasDivider" ></itb-divider>
</div>